import { StyledCreateTownhallModal } from "./styledComponents";
import { CreateTownhallModalContent, CreateTownhallModalProps } from "./CreateTownhallModalContent";

/**
 * Create Townhall Modal component
 */
export const CreateTownhallModal = (props: CreateTownhallModalProps) => {
    const { mode = "kwebcast", ...formProps } = props;

    return (
        <StyledCreateTownhallModal open={formProps.open} classes={{ paper: "kms-ds-create-townhall-modal" }}>
            <CreateTownhallModalContent mode={mode} {...formProps} />
        </StyledCreateTownhallModal>
    );
};
